import { Phone, Mail, Users, FileText } from 'lucide-react';
import { formatDistanceToNow, format } from 'date-fns';

const typeConfig = {
  call: { icon: Phone, label: 'Phone Call', class: 'activity-call', bg: 'bg-green-500' },
  email: { icon: Mail, label: 'Email', class: 'activity-email', bg: 'bg-blue-500' },
  meeting: { icon: Users, label: 'Meeting', class: 'activity-meeting', bg: 'bg-purple-500' },
  note: { icon: FileText, label: 'Note', class: 'activity-note', bg: 'bg-amber-500' },
};

export const ActivityTimeline = ({ followups }) => {
  if (followups.length === 0) {
    return (
      <div className="text-center py-6 text-muted-foreground">
        <p className="text-sm">No activity yet</p>
        <p className="text-xs mt-1">Log your first follow-up above</p>
      </div>
    );
  }

  return (
    <div className="relative pl-6 border-l border-border ml-2 space-y-4" data-testid="activity-timeline">
      {followups.map((followup) => {
        const config = typeConfig[followup.type] || typeConfig.note;
        const Icon = config.icon;
        
        const getDate = () => {
          try {
            const date = new Date(followup.created_at);
            return {
              relative: formatDistanceToNow(date, { addSuffix: true }),
              absolute: format(date, 'MMM d, yyyy h:mm a')
            };
          } catch {
            return { relative: 'recently', absolute: '' };
          }
        };
        
        const dateInfo = getDate();

        return (
          <div key={followup.id} className="relative group animate-slideInUp" data-testid={`activity-${followup.id}`}>
            {/* Timeline connector */}
            <div className={`absolute -left-[25px] w-3 h-3 rounded-full ${config.bg} ring-4 ring-background`} />
            
            <div className="bg-muted/30 rounded-lg p-3 hover:bg-muted/50 transition-colors">
              <div className="flex items-center gap-2 mb-2">
                <Icon className={`w-4 h-4 ${config.class}`} />
                <span className="font-medium text-sm">{config.label}</span>
                <span className="text-xs text-muted-foreground ml-auto mono-text" title={dateInfo.absolute}>
                  {dateInfo.relative}
                </span>
              </div>
              
              <p className="text-sm text-foreground/90">{followup.notes}</p>
              
              <p className="text-xs text-muted-foreground mt-2">
                by {followup.user_name}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
